import React from 'react';

const severityIcons = {
  critical: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M9 1.5L1 16h16L9 1.5zm0 3l5.74 10H3.26L9 4.5zM8.25 8v3.5h1.5V8h-1.5zm0 4.5v1.5h1.5v-1.5h-1.5z"/>
    </svg>
  ),
  warning: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M9 1a8 8 0 100 16A8 8 0 009 1zm-.75 4.5h1.5v5h-1.5v-5zm0 6.5h1.5V13.5h-1.5V12z"/>
    </svg>
  ),
  info: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <path d="M9 1a8 8 0 100 16A8 8 0 009 1zm.75 4v1.5h-1.5V5h1.5zm0 3v5.5h-1.5V8h1.5z"/>
    </svg>
  )
};

function AlertPanel({ alerts, isProcessing }) {
  if (isProcessing) {
    return (
      <div className="alert-panel card">
        <h3 className="card-title">Alerts & Violations</h3>
        <div className="alert-placeholder">
          <div className="shimmer-line"></div>
          <div className="shimmer-line short"></div>
        </div>
      </div>
    );
  }

  const sortedAlerts = [...alerts].sort((a, b) => {
    const order = { critical: 0, warning: 1, info: 2 };
    return (order[a.severity] || 2) - (order[b.severity] || 2);
  });

  const criticalCount = alerts.filter(a => a.severity === 'critical').length;
  const warningCount = alerts.filter(a => a.severity === 'warning').length;

  return (
    <div className="alert-panel card">
      <div className="card-header">
        <h3 className="card-title">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path d="M15 5.6L12.4 3 6 9.4V12h2.6L15 5.6zM16.7 4.3l-1-1a1 1 0 00-1.4 0l-1 1 2.4 2.4 1-1a1 1 0 000-1.4zM2 14h14v2H2v-2z"/>
          </svg>
          Alerts & Violations
        </h3>
        {alerts.length > 0 && (
          <div className="alert-counts">
            {criticalCount > 0 && (
              <span className="alert-count critical">{criticalCount} Critical</span>
            )}
            {warningCount > 0 && (
              <span className="alert-count warning">{warningCount} Warning</span>
            )}
          </div>
        )}
      </div>

      {sortedAlerts.length === 0 ? (
        <div className="no-alerts">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="#10b981" strokeWidth="2">
            <circle cx="16" cy="16" r="12"/>
            <path d="M10 16l4 4 8-8"/>
          </svg>
          <p>No alerts triggered</p>
        </div>
      ) : (
        <div className="alerts-list">
          {sortedAlerts.map((alert, i) => (
            <div key={i} className={`alert-item alert-${alert.severity}`}>
              <div className="alert-icon">{severityIcons[alert.severity]}</div>
              <div className="alert-content">
                <span className="alert-badge">{alert.severity.toUpperCase()}</span>
                <p className="alert-message">{alert.message}</p>
                {alert.rule && <span className="alert-rule">Rule: {alert.rule}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AlertPanel;
